import React from 'react';
import EditorialLayout from '@/components/editorial/EditorialLayout';
import { ErrorDashboard } from '@/components/monitoring/ErrorDashboard';

const MonitoringPage: React.FC = () => {
  return (
    <EditorialLayout>
      <ErrorDashboard />
    </EditorialLayout>
  );
};

export default MonitoringPage;